export default function Marquee() {
  const text = "S&P Reinigungsservice — Esterwegen — Streifenfrei sauber — ";
  return (
    <section className="relative border-y border-white/10 bg-[#0A111F] py-10 overflow-hidden">
      <div className="flex w-max marquee-track whitespace-nowrap">
        {[0, 1].map((k) => (
          <span key={k} className="flex items-center">
            {Array.from({ length: 4 }).map((_, i) => (
              <span
                key={i}
                className="font-heading text-5xl md:text-7xl font-semibold tracking-tight text-outline px-6"
              >
                {text}
              </span>
            ))}
          </span>
        ))}
      </div>
    </section>
  );
}
